module.exports = __webpack_public_path__ + "media/images/area/tokyo_hero_img_pc-51efecc21d25addb274d059d00c919d5.jpg";